import { LoadCartFromQuery } from './cart-loader';
import { CreateState } from './state';
import { DrawInitialCart, SetupSummary } from './summary';
import { SetupShipping } from './shipping';
import { SetupSmartPayWarning } from './smartpay';
import { SetupTax } from './tax';
import { SetupPayment } from './payment';
import { SetupAdditional } from './additional';
import { SetupSubmit } from './submit';
import { ApplyResumableOrder, SetupResume } from './resume';
import * as carts from '../carts';
import { MountStaffNudge } from 'smg/staff-nudge';

void main();

// main orchestrates the checkout page: load cart from the URL, build
// shared state, let each section wire its DOM + callables, then fetch
// the initial cart and open the shipping accordion (or resume an
// unfinished order when the cart bootstrap reports one).
async function main(): Promise<void> {
    const cartReloader = await LoadCartFromQuery();

    const state = await CreateState();
    state.cartReloader = cartReloader;

    SetupSummary(state);
    SetupShipping(state);
    SetupTax(state);
    SetupPayment(state);
    SetupSmartPayWarning(state);
    SetupAdditional(state);
    SetupSubmit(state);
    SetupResume(state);

    await state.updateOrderSummary();
    const cartResp = await DrawInitialCart(state);

    // Resume before initShipping: for a guest with no saved addresses,
    // initShipping's promptShippingOption clicks the shipping toggle open,
    // whose shown.bs.collapse handler reveals every section — including the
    // additional-details section resume keeps hidden. A resumed checkout
    // skips shipping setup entirely (the section is locked); "Start over"
    // re-runs it through the toggle's own click handler.
    const resumed = await ApplyResumableOrder(state, cartResp?.resumableOrder);
    if (!resumed) {
        await state.initShipping();
        state.dom.$shippingBodyToggle?.click();
    }

    // Nudge SMG staff to finish the order in IAP instead of the customer checkout
    // (invisible for everyone else). Runs last so it never blocks checkout setup.
    const $panels = document.querySelector('#checkout-main-panels');
    if ($panels) {
        MountStaffNudge({ anchor: $panels, cartID: carts.GetCartID() || '' });
    }
}
